import { BillableType, Shipment } from "@api/graphql/generated/generated-types";

/** True when the shipment's order is never billed, so its customer price is $0. */
export function isShipmentNotBilled(shipment: Shipment | null | undefined): boolean {
  return shipment?.order?.billableType === BillableType.NonBillable;
}
